export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10002.de6f1d47.jpg";